import { useEffect, useState } from "react";
import { Commons, Const } from "./constants";

import { CancelButton, ModalComponent, trans, TableComponent, EmployeeWithProfile } from "@comps/components"
import moment from "moment";
const ViewRequestHistory = (props) => {
  const langKey = Const["requestHistory"].lngKey
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    setData();
  }, []);

  const setData = () => {
    if (!props) {
      return;
    }
    if (props.record.histories) {
      setDataSource(props.record.histories);
    }
  }

  const footer = [
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  const columns = [
    {
      key: 'requestee',
      title: trans(`${langKey}.requestee`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.next_requestee_name } />
      },
    },
    {
      key: 'status',
      title: trans(`${langKey}.status`),
      dataIndex: 'status'
    },
    {
      key: 'remarks',
      title: trans(`${langKey}.remarks`),
      dataIndex: 'remarks'
    },
    {
      key: 'datetime',
      title: trans(`${langKey}.datetime`),
      render: (record) => {
        return moment(new Date(record.created_at)).format('YYYY-MM-DD hh:mm a')
      }
    },
    // dataSource[0].approved_amount !== undefined &&
    // {
    //   key: 'approved_amount',
    //   title: 'Approved Amount',
    //   dataIndex: 'approved_amount'
    // },
  ];
  return (
    <ModalComponent top={ 20 } width={ 600 } maskClosable={ false }
      mainTitle={ trans(Commons.view) } subTitle={ 'History' }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) } disabled={ props.disabled } loader={ true }>
      <TableComponent
        columns={ columns }
        dataSource={ dataSource }
        pagination={ false }
      />
    </ModalComponent>
  )
}

export default ViewRequestHistory